var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWheeliconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    "data-name": "Grupo 56",
    transform: "translate(-1009 -128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun_Wheel_2234409",
    d: "M20.519,19.259a.457.457,0,0,1,.377-.221h4.252a3.135,3.135,0,0,0,.044-.642,6.225,6.225,0,0,0-.022-.642H20.9a.429.429,0,0,1-.377-.221l-.354-.6a.4.4,0,0,1,0-.443l2.1-3.558-.831-.615-2.381,3.53a.429.429,0,0,1-.377.221h-.709a.429.429,0,0,1-.377-.221l-2.126-3.7a6.869,6.869,0,0,0-1.107.642l2.126,3.7a.4.4,0,0,1,0,.443l-.354.6a.457.457,0,0,1-.377.221H11.483a6.224,6.224,0,0,0-.022.642,6.224,6.224,0,0,0,.022.642h4.252a.429.429,0,0,1,.377.221l.354.6a.4.4,0,0,1,0,.443L14.34,23.977a6.869,6.869,0,0,0,1.107.642l2.126-3.677a.429.429,0,0,1,.377-.221h.709a.429.429,0,0,1,.377.221l2.126,3.677a6.869,6.869,0,0,0,1.107-.642L20.143,20.3a.4.4,0,0,1,0-.443Zm-2.193.687a1.541,1.541,0,1,1,1.1-.452,1.55,1.55,0,0,1-1.1.452Zm.664-1.55a.665.665,0,1,1-.665-.665A.665.665,0,0,1,18.99,18.4Z",
    transform: "translate(999.754 118.524)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_981",
    "data-name": "Elipse 981",
    transform: "translate(1009 128)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheeliconBlack);
export default __webpack_public_path__ + "static/media/wheelicon_black.fbcf3603.svg";
export { ForwardRef as ReactComponent };